import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@/shared/lib/cn';
import './Rank.css';

export type RankTier = 'silver' | 'gold' | 'diamond' | 'kingdom';

const TIER_CONFIG: Record<RankTier, { label: string; letter: string }> = {
  silver: { label: 'Plata', letter: 'P' },
  gold: { label: 'Oro', letter: 'O' },
  diamond: { label: 'Diamante', letter: 'D' },
  kingdom: { label: 'Kingdom', letter: 'K' },
};

export interface RankProps extends HTMLAttributes<HTMLSpanElement> {
  tier: RankTier;
  showLabel?: boolean;
}

export const Rank = forwardRef<HTMLSpanElement, RankProps>(function Rank(
  { tier, showLabel = true, className, ...rest },
  ref,
) {
  const cfg = TIER_CONFIG[tier];
  return (
    <span
      ref={ref}
      className={cn('itb-rank', `itb-rank--${tier}`, className)}
      {...rest}
    >
      <span className="itb-rank__icon" aria-hidden>{cfg.letter}</span>
      {showLabel && cfg.label}
    </span>
  );
});
